import {
    ClientProviderPreference,
    extractPsychotherapyAuthorizedHours,
    Offer,
    PsychotherapyAuthorizedHour,
    Referral
} from "../../domains";
import {PAGE} from "../../const";
import {ProviderOfferDetailItem} from "./ProviderOfferDetailItem";
import { groupBy } from "lodash";
import {filterOfferByRecentPage} from "./common";
import {UnmatchReturnOfferModalState} from "../ProviderOfferReturnedModal";

type providerOfferDetailListViewProps = {
    offers: Array<Offer>;
    referral: Referral;
    selectedItem: Offer | null;
    setSelectedItem: (offer: Offer | null) => void;
    setUnmatchReturnModalState: (state: UnmatchReturnOfferModalState) => void;
    recentPage: PAGE;
    prefsSibling: ClientProviderPreference[];
    psychotherapyAuthorizedHour?: PsychotherapyAuthorizedHour | null;
}

export function ProviderOfferDetailListView({
                                         offers,
                                         selectedItem,
                                         referral,
                                         setUnmatchReturnModalState,
                                         recentPage,
                                         setSelectedItem,
                                         prefsSibling
                                     }: providerOfferDetailListViewProps) {

    const preferencesByProviderSfIds = groupBy([...prefsSibling, ...referral.clientProviderPreferences], p => p.sfProviderId);

    return (<div className='flex-grow scrollbar-always'>
        {
            filterOfferByRecentPage(offers, recentPage).map((offer) =>
                <ProviderOfferDetailItem
                    offer={offer}
                    key={offer.id}
                    setSelect={() => setSelectedItem(offer)}
                    isSelected={selectedItem !== null && selectedItem.id === offer.id}
                    isMatched={referral?.matchedOffer?.guid === offer.guid}
                    recentPage={recentPage}
                    showReturnModal={() => setUnmatchReturnModalState('Return')}
                    referralRequiredLanguage={referral.requiredLanguage}
                    psychotherapyAuthorizedHour={extractPsychotherapyAuthorizedHours(referral)}
                    preferences={offer.providerSfId ? preferencesByProviderSfIds[offer.providerSfId] : []}
                />
            )
        }
    </div>);
}
